import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';

@Component({
    selector: 'app-leave-type-filter',
    templateUrl: './leave-type-filter.component.html',
    styleUrls: ['./leave-type-filter.component.scss'],
    standalone: false
})
export class LeaveTypeFilterComponent implements OnInit {
    @Input() LeaveTypeControl: UntypedFormControl;
    @Output() LeaveTypeSelected = new EventEmitter();

    leaveTypeOptions: any[];

    constructor(
        private selectionService: SelectionGenericService,
        private sharedService: SharedService,
        public filterService: FilterService
    ) {}

    ngOnInit(): void {
        this.leaveTypeOptions = [
            { text: 'Todos con gestion', value: '1' },
            { text: 'Todos sin gestion', value: '2' },
            { text: 'Enfermedad', value: 'E' },
            { text: 'Enfermedad profesional', value: 'F' },
            { text: 'Accidente laboral', value: 'A' },
            { text: 'Accidente no laboral', value: 'N' },
            { text: 'Accidente sin baja', value: 'S' },
            { text: 'Indisposición', value: 'I' },
            { text: 'Riesgo por embarazo', value: 'R' },
            { text: 'Maternidad', value: 'M' },
            { text: 'Permiso', value: 'P' },
            { text: 'Permiso retribuido', value: 'B' },
            { text: 'Permiso no retribuido', value: 'U' },
            { text: 'Incapacidad', value: 'X' },
        ];
    }

    SetLeaveType(): any {
        const leaveTypeArray = this.LeaveTypeControl.value;
        this.LeaveTypeSelected.emit(leaveTypeArray);
    }
}
